// Contenido de muestra para el panel derecho "La Brújula" (radar) del
// login — alternativa a EcosystemPanel/Carousel3D, ver
// design_handoff_sustemia_login/README.md. Mismos datos de muestra que
// usa el resto del panel derecho (1.240 tCO₂e, 68% plan anual, etc.);
// en producción vendrían de la API.
const radarByLang = {
  es: {
    headline: ["mientras", "tu planta", "duerme,"],
    headlineHighlight: ["los datos", "trabajan."],
    subtitle: "Cada lectura entra sola, se convierte sola y te espera lista para decidir.",
    footerTagline: "AHORA GESTIONAS CON DATOS · 100% DIGITAL",
    blips: [
      { pos: 0, pillar: "AMBIENTAL · GEI", value: "1.240 tCO₂e" },
      { pos: 1, pillar: "AMBIENTAL · ENERGÍA", value: "12.480 kWh" },
      { pos: 2, pillar: "SEGURIDAD · PLAN ANUAL", value: "68%" },
      { pos: 3, pillar: "SOCIAL · DILIGENCIA", value: "5/5" },
      { pos: 4, pillar: "SEGURIDAD · LEGAL", value: "87%" },
    ],
    ticker: [
      { label: "ENERGÍA", value: "12.480 kWh" },
      { label: "AGUA", value: "3.240 m³" },
      { label: "EFLUENTES", value: "98%" },
      { label: "GEI", value: "1.240 tCO₂e" },
      { label: "RESIDUOS", value: "71%" },
      { label: "VEHÍCULOS", value: "18" },
      { label: "PLAN ANUAL", value: "68%" },
      { label: "MATRIZ LEGAL", value: "87%" },
      { label: "ACCIDENTES", value: "0" },
      { label: "PERMISOS", value: "14" },
      { label: "DEBIDA DILIGENCIA", value: "5/5" },
      { label: "RIESGOS SOCIALES", value: "3" },
    ],
  },
  en: {
    headline: ["while", "your plant", "sleeps,"],
    headlineHighlight: ["the data", "works."],
    subtitle: "Every reading comes in on its own, converts itself, and waits ready for you to decide.",
    footerTagline: "NOW YOU MANAGE WITH DATA · 100% DIGITAL",
    blips: [
      { pos: 0, pillar: "ENVIRONMENTAL · GHG", value: "1,240 tCO₂e" },
      { pos: 1, pillar: "ENVIRONMENTAL · ENERGY", value: "12,480 kWh" },
      { pos: 2, pillar: "SAFETY · ANNUAL PLAN", value: "68%" },
      { pos: 3, pillar: "SOCIAL · DILIGENCE", value: "5/5" },
      { pos: 4, pillar: "SAFETY · LEGAL", value: "87%" },
    ],
    ticker: [
      { label: "ENERGY", value: "12,480 kWh" },
      { label: "WATER", value: "3,240 m³" },
      { label: "EFFLUENTS", value: "98%" },
      { label: "GHG", value: "1,240 tCO₂e" },
      { label: "WASTE", value: "71%" },
      { label: "VEHICLES", value: "18" },
      { label: "ANNUAL PLAN", value: "68%" },
      { label: "LEGAL MATRIX", value: "87%" },
      { label: "ACCIDENTS", value: "0" },
      { label: "PERMITS", value: "14" },
      { label: "DUE DILIGENCE", value: "5/5" },
      { label: "SOCIAL RISKS", value: "3" },
    ],
  },
  pt: {
    headline: ["enquanto", "sua fábrica", "dorme,"],
    headlineHighlight: ["os dados", "trabalham."],
    subtitle: "Cada leitura entra sozinha, se converte sozinha e espera pronta para você decidir.",
    footerTagline: "AGORA VOCÊ GESTIONA COM DADOS · 100% DIGITAL",
    blips: [
      { pos: 0, pillar: "AMBIENTAL · GEE", value: "1.240 tCO₂e" },
      { pos: 1, pillar: "AMBIENTAL · ENERGIA", value: "12.480 kWh" },
      { pos: 2, pillar: "SEGURANÇA · PLANO ANUAL", value: "68%" },
      { pos: 3, pillar: "SOCIAL · DILIGÊNCIA", value: "5/5" },
      { pos: 4, pillar: "SEGURANÇA · LEGAL", value: "87%" },
    ],
    ticker: [
      { label: "ENERGIA", value: "12.480 kWh" },
      { label: "ÁGUA", value: "3.240 m³" },
      { label: "EFLUENTES", value: "98%" },
      { label: "GEE", value: "1.240 tCO₂e" },
      { label: "RESÍDUOS", value: "71%" },
      { label: "VEÍCULOS", value: "18" },
      { label: "PLANO ANUAL", value: "68%" },
      { label: "MATRIZ LEGAL", value: "87%" },
      { label: "ACIDENTES", value: "0" },
      { label: "PERMISSÕES", value: "14" },
      { label: "DILIGÊNCIA DEVIDA", value: "5/5" },
      { label: "RISCOS SOCIAIS", value: "3" },
    ],
  },
};

// Posición (top/left, %) de cada blip sobre el radar — copiada 1:1 del
// diseño original (design_handoff_sustemia_login/disenos/Sustemia Login.dc.html).
export const RADAR_BLIP_POSITIONS = [
  { left: "58%", top: "14%", delay: "0s" },
  { left: "12%", top: "38%", delay: "1.2s" },
  { left: "64%", top: "62%", delay: "2.2s" },
  { left: "24%", top: "78%", delay: "3s" },
  { left: "70%", top: "36%", delay: "0.6s" },
];

export function getRadarData(language) {
  return radarByLang[language] || radarByLang.es;
}
